import { useContext } from 'react';
import { FormControlLabel, Grid, Checkbox, TextField, Link } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { applicationContext, appUserContext } from 'helpers/services';
import { IBulkEditRequest } from '../BulkEditContext';


interface IProps {
    request: IBulkEditRequest
    updateRequest: (newRequest: IBulkEditRequest) => void
}

let CSAssignee = ({ request, updateRequest }: IProps) => {
    let { currentUser } = useContext(appUserContext);
    let { customerServiceUsers } = useContext(applicationContext);


    return (
        <>
            <Grid item xs={4}>
                <FormControlLabel
                    checked={request.changeCSAssignee}
                    control={<Checkbox />}
                    label="Customer Service Assignee"
                    onChange={(e, value) => {
                        updateRequest({
                            ...request,
                            changeCSAssignee: value
                        })
                    }}
                />
            </Grid>

            {request.changeCSAssignee &&
                <Grid item xs>
                    <Autocomplete
                        value={request.csAssignee}
                        onChange={(e, newValue) => updateRequest({ ...request, csAssignee: newValue || "" })}
                        getOptionLabel={(option) => customerServiceUsers.getValueByKey(option)}
                        options={customerServiceUsers.map(x => x.key)}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                variant="outlined"
                                label="Customer service assignee"
                            />
                        }
                    />
                    {currentUser?.groups.find(z => z === "CUSTOMER_SERVICE") && currentUser?.email !== request.csAssignee &&
                        <Link
                            color="error"
                            variant="body2"
                            style={{ cursor: 'pointer' }}
                            onClick={() => updateRequest({
                                ...request,
                                csAssignee: currentUser?.email || ""
                            })}
                        >
                            Assign to me
                        </Link>
                    }
                </Grid>
            }
        </>
    )
}

export default CSAssignee;